import { categorySchema } from "@/schema/app/assessment/category";
import { statusSchema } from "@/schema/app/assessment/status";
import { documentSchema } from "@/schema/app/document";
import { z } from "zod";

export const assessmentSchema = z.object({
  id: z.number(),
  status: statusSchema,
  has_first_evaluation_report: z.coerce.boolean(),
  has_second_evaluation_report: z.coerce.boolean(),
  has_improvement_proposal: z.coerce.boolean(),
  submitted_at: z.coerce.date().nullish(),
  issued_at: z.coerce.date().nullish(),
  expired_at: z.coerce.date(),
  categories: z.array(categorySchema),
  company_document_files: z.array(documentSchema),
});

export type Assessment = z.infer<typeof assessmentSchema>;
